import styled from 'styled-components'

const TextContainer = styled.div`
  font-size: ${props => props.theme.font.size.base};
  font-weight: ${props => props.theme.font.weight.regular};
  line-height: ${props => props.theme.font.stack['body-1']['line-height']};
  align-self: center;
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 10px;
  border-left: 1px solid ${props => props.theme.color.monochrome.light};
  max-width: 80%;
  display: inline;
  white-space: normal;
`

const Link = styled.button`
  color: ${props => props.theme.color.palette['brand-1']};
  font-weight: ${props => props.theme.font.weight.bold};
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;

  background: none;
  border: none;
  outline: none;
  box-shadow: none;

  &:hover,
  &:active {
    color: ${props => props.theme.color.palette['brand-1-dark']};
  }
`
export { TextContainer, Link }
